import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import EventCharts from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { getToolById } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import Paid from '@components/ncFiles/components/paid';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';

interface ToolsDetailsNCFilePerformancePaidProps {}

const ToolsDetailsNCFilePerformancePaidComponent: FC<ToolsDetailsNCFilePerformancePaidProps> = ({
  getToolById,
  updateHeaderConfig,
  getNCFileById,
}) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <Paid {...props} />} />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFilePerformancePaid = connect(({}) => ({}), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFilePerformancePaidComponent);

export { ToolsDetailsNCFilePerformancePaid };
